import React, { useState, useRef, useEffect } from "react";
import style from './block.module.scss';
import {defineBlock, smartProps, useEditor, EditableText, useSmartProp, useInspectorControl} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, ToggleControl, SelectControl  } from '@wordpress/components';

function Inspector(){
    const [required, setRequired] = useSmartProp("required");
    const [typeField, setTypeField] = useSmartProp('typeField');
    const [name, setName] = useSmartProp('name');

    return <PanelBody title="Options" initialOpen={true}>
                <PanelRow>
                    <SelectControl
                        value={typeField}
                        label="Type of field" 
                        options={ [
                            { label: 'Text', value: 'text' },
                            { label: 'Url', value: 'url' },
                            { label: 'Mail', value: 'email' },
                            { label: 'Number', value: 'number' },
                            { label: 'Phone', value: 'tel' },
                        ] }
                        onChange={setTypeField}
                    />
                </PanelRow>
                <PanelRow>
                    <ToggleControl
                        label="Required"
                        checked={required}
                        onChange={() =>setRequired(!required)}
                    />
                </PanelRow>
                <PanelRow>
                    <SelectControl
                        label="Name"
                        value={name}
                        options={ [
                            { label: 'Last name', value: 'name' },
                            { label: 'First name', value: 'firstname' },
                            { label: 'Zipcode', value: 'zip' },
                            { label: 'Phone', value: 'phone' },
                            { label: 'Mail address', value: 'email' },
                            { label: 'Company Name', value: 'company' },
                            { label: 'Customer number', value: 'customer_number' },
                        ] }
                        onChange={(name) =>setName(name)}
                    />
                </PanelRow>
            </PanelBody>
}

function FormInput({label, placeholder, required, typeField, name}){
    const { isEditing } = useEditor();
    const [value, setValue] = useState("");
    const refBlock = useRef();
    useInspectorControl(Inspector);

    function onChange(e) {
        if(refBlock && refBlock.current) {
            var event = new CustomEvent("smartfire.smartform.onChange", {
                detail: {
                    name,
                    value: e.target.value,
                    form: refBlock.current.closest(".smartform"),
                    event: e,
                },
                bubbles: true,
                cancelable: true,
            });
            e.target.dispatchEvent(event);
        }
        setValue(e.target.value);
    }

    // Initiate value for conditional field
    useEffect(() => {
        const onLoad = () => {
            if(refBlock && refBlock.current) {
                var event = new CustomEvent("smartfire.smartform.onChange", {
                    detail: {
                        name,
                        value: "",
                        form: refBlock.current.closest(".smartform"),
                        event: null,
                    },
                    bubbles: true,
                    cancelable: true,
                });
                refBlock.current.dispatchEvent(event);
            }
        };
        window.addEventListener("load", onLoad);
        return () => {
            window.removeEventListener("load", onLoad);
        }
    }, [refBlock, name]);

    return <div className={style.container}>
        { isEditing ? 
            <>
                <div className={style.input} required={required} type={typeField}><EditableText tagName="span" smartProp="placeholder" /> {required ? "*" : ""}</div>
                <input name={name} type="hidden" />
            </>:
            <><input ref={refBlock} className={style.input} placeholder={`${placeholder} ${required ? "*" : ""}`} name={name} required={required} type={typeField} onChange={onChange} value={value} />
            <span className={style.border}></span></>
        }
    </div>
}

export default defineBlock({
    Block: FormInput,
    smartProps: {
        placeholder: smartProps.string.withDefault('placeholder'),
        required: smartProps.bool.withDefault(false),
        typeField: smartProps.string.withDefault('text'),
        name: smartProps.string.withDefault('name')
    },
    setup: {
        title: "Input",
        parent: ["smartfire/form", "smartfire/form-2-cols"],
        category: "two-third"
    }
});